(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', 'react', 'prop-types', 'calidators'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('prop-types'), require('calidators'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.propTypes, global.calidators);
        global.ValidatorsContext = mod.exports;
    }
})(this, function (exports, _react, _propTypes, _calidators) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.withValidators = exports.ValidatorsConsumer = exports.ValidatorsProvider = undefined;

    var _react2 = _interopRequireDefault(_react);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var defaultValidators = {
        isBlacklisted: _calidators.isBlacklisted,
        isEmail: _calidators.isEmail,
        isEqual: _calidators.isEqual,
        isGreaterThan: _calidators.isGreaterThan,
        isLessThan: _calidators.isLessThan,
        isRequired: _calidators.isRequired,
        isNumber: _calidators.isNumber,
        isRegexMatch: _calidators.isRegexMatch,
        isWhitelisted: _calidators.isWhitelisted,
        isMinLength: _calidators.isMinLength,
        isMaxLength: _calidators.isMaxLength,
        isExactLength: _calidators.isExactLength
    };

    var _createContext = (0, _react.createContext)({}),
        Provider = _createContext.Provider,
        Consumer = _createContext.Consumer;

    var ValidatorsProvider = exports.ValidatorsProvider = function (_Component) {
        _inherits(ValidatorsProvider, _Component);

        function ValidatorsProvider() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, ValidatorsProvider);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ValidatorsProvider.__proto__ || Object.getPrototypeOf(ValidatorsProvider)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends({}, _this.props.validators), _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(ValidatorsProvider, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement(
                    Provider,
                    { value: this.state },
                    this.props.children
                );
            }
        }], [{
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps) {
                return nextProps.validators || null;
            }
        }]);

        return ValidatorsProvider;
    }(_react.Component);

    ValidatorsProvider.defaultProps = {
        validators: {}
    };
    ValidatorsProvider.propTypes = {
        validators: (0, _propTypes.shape)({})
    };
    var ValidatorsConsumer = exports.ValidatorsConsumer = Consumer;

    var withValidators = exports.withValidators = function withValidators(TargetComponent) {
        var WithValidators = function WithValidators(props) {
            return _react2.default.createElement(
                Consumer,
                null,
                function (validators) {
                    return _react2.default.createElement(TargetComponent, _extends({}, props, {
                        validators: _extends({}, defaultValidators, validators)
                    }));
                }
            );
        };
        var targetName = TargetComponent.displayName || TargetComponent.name;

        WithValidators.displayName = 'withValidators(' + targetName + ')';

        return WithValidators;
    };
});